import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";
import { Injectable } from "@nestjs/common";
import { OverTimeEntity } from "../over-time.entity";
import { OverTimeDTO } from "./over-time-apply.dto";

@Injectable()
export class OverTimeAdapter {

    public converDtoToEntity(overTimeDTO: OverTimeDTO): OverTimeEntity {
        const overTimeEntity = new OverTimeEntity();
        overTimeEntity.otId = overTimeDTO.otId;
        overTimeEntity.employeeCode = overTimeDTO.employeeCode;
        overTimeEntity.employeeName = overTimeDTO.employeeName;
        overTimeEntity.date = overTimeDTO.date;
        overTimeEntity.inTime = overTimeDTO.inTime;
        overTimeEntity.outTime = overTimeDTO.outTime;
        overTimeEntity.workingHours = overTimeDTO.workingHours;
        overTimeEntity.otType = overTimeDTO.otType;
        overTimeEntity.otHours = overTimeDTO.otHours;
        overTimeEntity.status = LeaveApprovalStatusEnum.OPEN;
        overTimeEntity.month = overTimeDTO.month;
        overTimeEntity.createdUser = overTimeDTO.createdUser;

        return overTimeEntity;
    }

    public convertEntityToDto(overTimeCatObject: OverTimeEntity): OverTimeDTO {
        const overTimeDTO = new OverTimeDTO;
        overTimeDTO.otId = overTimeCatObject.otId;
        overTimeDTO.employeeCode = overTimeCatObject.employeeCode;
        overTimeDTO.employeeName = overTimeCatObject.employeeName;
        overTimeDTO.date = overTimeCatObject.date;
        overTimeDTO.inTime = overTimeCatObject.inTime;
        overTimeDTO.outTime = overTimeCatObject.outTime;
        overTimeDTO.workingHours = overTimeCatObject.workingHours;
        overTimeDTO.otType = overTimeCatObject.otType;
        overTimeDTO.otHours = overTimeCatObject.otHours;
        overTimeDTO.status = overTimeCatObject.status;
        overTimeDTO.month = overTimeCatObject.month;
        overTimeDTO.createdUser = overTimeCatObject.createdUser;

        return overTimeDTO;
    }
}